import React, { useState } from "react";

// Round avatar with a rank-coloured ring and an elegant monogram fallback.
export const ChampionAvatar = ({ champion, ringStyle, sizeClass = "h-24 w-24", textClass = "text-xl" }) => {
  const [failed, setFailed] = useState(false);
  const showImg = champion.photo && !failed;

  return (
    <div
      className={`${sizeClass} relative overflow-hidden rounded-full bg-mds-navy`}
      style={ringStyle}
    >
      {showImg ? (
        <img
          src={champion.photo}
          alt={champion.name}
          className="h-full w-full scale-[1.16] object-cover"
          loading="lazy"
          draggable={false}
          onError={() => setFailed(true)}
        />
      ) : (
        <div
          className={`flex h-full w-full items-center justify-center bg-gradient-to-br from-mds-green to-mds-navy font-display ${textClass} text-mds-goldlt`}
        >
          {champion.initials}
        </div>
      )}
    </div>
  );
};
